import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import twitterFill from '@iconify/icons-eva/twitter-fill'
import linkedinFill from '@iconify/icons-eva/linkedin-fill'
import facebookFill from '@iconify/icons-eva/facebook-fill'
import instagramFilled from '@iconify/icons-ant-design/instagram-filled'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import { sentenceCase } from 'change-case'
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'

import {
  Box,
  Card,
  Grid,
  Avatar,
  Tooltip,
  Divider,
  Stack,
  Typography,
  IconButton,
  AvatarGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core'
// utils
import { fShortenNumber } from 'src/utils/formatNumber'
//
import SvgIconStyle from 'src/components/SvgIconStyle'
import Label from 'src/components/Label'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { Message, MessageSharp, RequestQuote } from '@material-ui/icons'
import moment from 'moment'
import { getAgoString } from 'src/common/Helper'
import { useSnackbar } from 'notistack'
import { Link } from 'react-router-dom'
import { empty } from 'src/Helpers/Common'
import { COMPANY_LOGO, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import QuickbookLogo from '../../../assets/quickbookLogo-removebg-preview.png'
import AVALARALOGO from '../../../assets/Avalara_Logo.png'
import { useState } from 'react'
import briefcaseFill from '@iconify/icons-eva/briefcase-fill';
import copyFill from '@iconify/icons-eva/copy-fill';
import FullScreenDialogEstimate from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogEstimate'
import FullScreenDialogSalesOrder from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogSalesOrder'
import { UserMoreMenu } from '../user/list'
import ConfirmationPopup from 'src/components/confirmationPopup'
import axios from 'axios'

// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    //  backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)', // Fix on Mobile
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
    // backgroundColor: alpha(theme.palette.primary.darker, 0.72)
  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  //    background: `url(${src}) center/cover no-repeat`
})

// ----------------------------------------------------------------------

function InfoItem(number) {
  return (
    <Grid item xs={4}>
      <Typography
        variant="caption"
        sx={{ mb: 0.5, color: 'text.secondary', display: 'block' }}
      >
        Follower
      </Typography>
      <Typography variant="subtitle1">{fShortenNumber(number)}</Typography>
    </Grid>
  )
}


const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 25,
  height: 28,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '5px',
  color: theme.palette.success.main,
  // backgroundColor: alpha(theme.palette.success.main, 0.16),
}));

export default function SplitEstimateCard({
  card,
  team_member,
  communityId,
  clientId,
  communityName,
  CommunityProjects,
  quotationView,
  proposalView,
  designOrder,
  setRenderCards,
  renderCards,
  handleOpenViewSalesOrder,
  handleOpenDetailsSalesOrder,
  setOpenSalesOrder,
  opeSalesOrder,
  handleOpenViewEstimate,
  handleOpenDetails,
  SalesOrderId,
  setSalesOrderId,
  salesOrderName,
  setSalesOrderName,
  removePopupData,
  openPurchaseOrder,
  setOpenPurchaseOrder,
  PurchaseOrderName,
  purchaseOrderId,
  isEditPurchaseOrder,
  setIsEditPurchaseOrder,
  setPurchaseOrderId,
  setPurchaseOrderName,
  CommunityJob,
  communityDesignOrder,
  handleOpenDetailsPurchaseOrder,
  handleOpenViewPurchaseOrder,
  estimateNewCard,
  salesOrderNewCard,
  designOrderNewCard,
  currentTab,
  isSalesOrder,
  isSplitEstimate
  // handleOpenEstimate,setHandleOpenEstimate,estimateId,setEstimateId,estimateName,setEstimateName,isEditEstimate,setIsEditEstimate
}) {
  console.log('currentTabeeeeeeeeeeeeeeeee', currentTab)
  const theme = useTheme()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');
  let user = JSON.parse(localStorage.getItem('user'))
  let isClient =user?.isClient
  
  let userType =isClient ? 3 : user.user_type
  let userId = user.user_id

  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }
  
  const explodedPermissions = user?.exploded_permissions
  const handleOpenEstimateTemp = localStorage.getItem(
    'estimateOpenProductionPopup',
  )
  const [handleOpenEstimate, setHandleOpenEstimate] = useState(
    handleOpenEstimateTemp || false,
  )
  const [estimateId, setEstimateId] = useState(false)
  const [estimateName, setEstimateName] = useState(false)
  const [isEditEstimate, setIsEditEstimate] = useState(false)

  const [isEditSalesOrder, setIsEditSalesOrder] = useState('')
  const {
    image,
    message,
    timestamp,
    id,
    added_by_profile_pic,
    name,
    status,
    hold,
    design_order_job_status,
    request,
    people,
    description,
    subject,
    submission_deadline,
    msg_count,
    proposal_count,
    participation_ends,
    installation_start_date,
    installation_end_date,
    services,
    accept_status,
    thumbnail,
    due_date,
    cover_image,
    invoice_total,
    invoice_grand_total,
    partners,
    customer_pic,
    community_name,
    installationStatus,
    allInstallationCompleted,
    installation_acceptance,
   customer_name,
   awarded,
   paymentMode,
   quotation_status,
   quotation,
   statusRfp,
   syncWithQuickbooks,
   doc_number,
   est_doc_number,
  min_payment_status,
  project_category,
  job_category_name,
  installationCompleteStatus,
  billing_type,
  noServiceNoTask,
  proj_status,
  attachment_count,
  send_client_app_req,
  attachment,
  isFromDesignOrder,
  duplicated_from,
  edited_by,
  isNewDesigns,
  isProject,
  isReview,
  avalara_code,
  partial_install,
  total_cost
} = card

console.log('proj_status proj_status',proj_status)

  const filteredAttachments = designOrder 
    ? attachment?.filter(imageItem=>(imageItem?.isDesign == 1 && (imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img"))) || [] 
    : attachment?.filter(imageItem=>(imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img")) || []
console.log('cardcardcardcard card',card)
 
  let customer_image = partners?.filter(
    (item) => item?.profile_pic != 'avatar.jpg',
  )
  let accepted_customer_image = partners
    ?.filter((item) => {
      item?.profile_pic != 'avatar.jpg' && item?.status == 1
    })
    ?.map((data) => {
      return data?.profile_pic
    })
  // console.log('customer_image--',customer_image);
  // console.log('accepted_customer_image--',accepted_customer_image);
  //  const currentUnix = moment().unix()
  //  console.log(currentUnix,'))))))))))))))))')
  //   console.log(submission_deadline,'$$$$$$$$$$$$$$$$')
  const updatedAt = moment.unix(timestamp).format('YYYY-MM-DD')
  //status color
  let CompletedStatus =
    installationCompleteStatus == 1
      ? 'Installs'
      : installationCompleteStatus == 2
      ? 'Pick up'
      : CommunityJob 
      ? 'Installs' 
      : installationCompleteStatus == 3 
      ? 'Shipping'
      : ''
  const getStatusColorAndLabel = (
    status,
    installationStatus,
    allInstallationCompleted,
    accepted,
    min_payment_status,
    billing_type,
    noServiceNoTask,
    proj_status,
    job_category_name,
    partial_install,
  ) => {
    switch (status) {
      case 1:
        return { color: 'primary', label: 'Open' }
      case 2:
        return { color:hold == 1 ? 'warning' : 'info', label: hold == 1 ? 'Hold' : 'Approved'}
      case 3:
        return { color: 'error', label: 'Rejected' }
      case 4:
        return { color: 'success', label: 'Converted' }
      case 5:
        return { color: hold == 1 ? 'warning' : 'success', label: hold == 1 ? 'Hold' : 'Products Added Successfully' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelQuickbid = (status, quotation) => {
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        return { color: 'info', label: 'Open' }
      case 3:
        return { color: 'primary', label: 'Evaluating' }
      case 4:
        return {
          color: quotation == 0 ? 'default' : 'success',
          label: quotation == 0 ? 'Archive' : 'Approved',
        }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelDesignOrder = (status, hold) => {
    switch (status) {
      case 1:
        return {
          color: hold == 1 ? 'warning' : 'info',
          label: hold == 1 ? 'Hold' : 'Open',
        }
      case 2:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Hold' : 'Approved ',
        } // Evaluating
      case 3:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Hold' : 'Approved',
        }
      case 4:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Draft',
        }
      case 5:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Closed',
        }
      case 6:
        return {
          color: hold == 1 ? 'warning' : 'error',
          label: hold == 1 ? 'Hold' : 'Rejected',
        }
      default:
        return {
          color: hold == 1 ? 'warning' : 'default',
          label: hold == 1 ? 'Hold' : 'Open',
        }
    }
  }
  const getStatusColorAndLabelForProposal = (status) => {
    switch (status) {
      case 1:
        return { color: 'info', label: 'Open' }
      case 2:
        return { color: 'warning', label: 'Awarded' }
      case 3:
        return { color: 'error', label: 'Rejected' }
      case 4:
        return { color: 'success', label: 'Approved' }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      case 7:
        return { color: 'success', label: 'Paid' }
      default:
        return { color: 'info', label: 'Open' }
    }
  }

  const handleUpdateHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
        {
          projectId: Number(id),
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const handleUpdateSalesOrderHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/update-sales-order-hold-status`,
        {
          request_id: Number(id),
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const option = [
    { id: 0, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Open' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Hold' },
    { id: 5, value: 'Approved' },
    { id: 6, value: 'Rejected' },
    { id: 7, value: 'Verified' },
    { id: 6, value: 'Reopen' },
  ]
  const colors = [
    'error',
    'primary',
    'secondary',
    'success',
    'warning',
    'success',
    'error',
    'success',
    'error',
  ]

  // const handleOpenViewEstimate = (id,name) =>{
  //   setIsEditEstimate(true)
  //   setEstimateId(id)
  //   setEstimateName(name)
  //   setHandleOpenEstimate(true)
  //   console.log('hjsfgdhjdhbfhhhh')
  //   localStorage.setItem('estimateProjectId', id);
  //   localStorage.setItem('estimateProjectName', name);
  //   localStorage.setItem('isEditEstimate', "true");
  //   localStorage.setItem('estimateOpenProductionPopup', 'true');

  // }
  // const handleOpenDetails= (id,name) =>{
  //   setIsEditEstimate(false)
  //   setEstimateId(id)
  //   setEstimateName(name)
  //   setHandleOpenEstimate(true)
  //   localStorage.setItem('estimateProjectId', id);
  //   localStorage.setItem('estimateProjectName', name);
  //   localStorage.setItem('isEditEstimate', "false");
  //   localStorage.setItem('estimateOpenProductionPopup', 'true');
  // }
  // const handleOpenViewSalesOrder = (id,name) =>{
  //   setIsEditSalesOrder(true)
  //   setSalesOrderId(id)
  //   setSalesOrderName(name)
  //   setOpenSalesOrder(true)
  //   localStorage.setItem('salesOrderProjectId', id);
  //   localStorage.setItem('salesOrderProjectName', name);
  //   localStorage.setItem('isEditSalesOrder', "true");
  //   localStorage.setItem('salesOrderOpenPopup', 'true');

  // }
  // const handleOpenDetailsSalesOrder= (id,name) =>{
  //   setIsEditSalesOrder(false)
  //   setSalesOrderId(id)
  //   setSalesOrderName(name)
  //   setOpenSalesOrder(true)
  //   localStorage.setItem('salesOrderProjectId', id);
  //   localStorage.setItem('salesOrderProjectName', name);
  //   localStorage.setItem('isEditSalesOrder', "false");
  //   localStorage.setItem('salesOrderOpenPopup', 'true');
  // }
  // const handleOpenViewPurchaseOrder = (id, name) => {
  //   setIsEditPurchaseOrder(true)
  //   setPurchaseOrderId(id)
  //   setPurchaseOrderName(name)
  //   setOpenPurchaseOrder(true)
  //   localStorage.setItem('purchaseOrderProjectId', id)
  //   localStorage.setItem('purchaseOrderProjectName', name)
  //   localStorage.setItem('isEditPurchaseOrder', 'true')
  //   localStorage.setItem('purchaseOrderOpenPopup', 'true')
  // }
  // const handleOpenDetailsPurchaseOrder = (id, name) => {
  //   setIsEditPurchaseOrder(false)
  //   setPurchaseOrderId(id)
  //   setPurchaseOrderName(name)
  //   setOpenPurchaseOrder(true)
  //   localStorage.setItem('purchaseOrderProjectId', id)
  //   localStorage.setItem('purchaseOrderProjectName', name)
  //   localStorage.setItem('isEditPurchaseOrder', 'false')
  //   localStorage.setItem('purchaseOrderOpenPopup', 'true')
  // }

  return (
    <>
    <Card
    sx={{ 
      ml: 2,
      height: '100%',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      opacity: quotationView && quotation_status === 4 && quotation === 0 ? '75%':'100%'
    }}
      // sx={{ ml: 2 , opacity: quotationView && quotation_status === 4 && quotation === 0 ? '75%':'100%'}}
      id={id}
      onClick={() => {
        navigate(PATH_DASHBOARD.quotation.viewSplitEstimate.replace(':id', id))
      }}
    >
      <CardMediaStyle>
  

 
          <CoverImgStyle
            alt="cover"
            src={
              filteredAttachments?.[0]?.name
                ? filteredAttachments[0].name
                : customer_pic && customer_pic !== 'avatar.jpg'
                ? customer_pic
                : COMPANY_LOGO
            }/>
          <Box
            sx={{
              position: 'absolute',
              top: 35,
              right: 10,
              zIndex: 20,
              borderRadius: '50%',
              backdropFilter: 'blur(6px)',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
            }}>




            </Box>
          <Stack sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{ position: 'absolute', top: 8, left: 10, zIndex: 10 }}
            >
              {CommunityProjects ? (
                <Label
                  variant="filled"
                  color={colors[status]}
                >
                  {option.find((opt) => opt.id === status).value}
                </Label>
              ) : (
                <Label
                  variant="filled"
                  color={
                    designOrder
                      ? getStatusColorAndLabelDesignOrder(status, hold).color
                      : quotationView
                      ? getStatusColorAndLabelQuickbid(
                          quotation_status,
                          quotation,
                        ).color
                      : proposalView
                      ? getStatusColorAndLabelForProposal(
                          userType != 3 ? (paymentMode ? 7 : awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                        ).color
                      : getStatusColorAndLabel(
                          status,
                          installationStatus,
                          allInstallationCompleted,
                          installation_acceptance,
                          min_payment_status,
                          billing_type,
                          noServiceNoTask,
                          proj_status,
                          job_category_name,
                          partial_install,
                        ).color
                  }
                >
                  <Tooltip
                    title={
                      designOrder
                        ? getStatusColorAndLabelDesignOrder(status, hold).label
                        : quotationView
                        ? getStatusColorAndLabelQuickbid(
                            quotation_status,
                            quotation,
                          ).label
                        : proposalView
                        ? getStatusColorAndLabelForProposal(
                            userType != 3 ? (paymentMode? 7:awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                          ).label
                        : getStatusColorAndLabel(
                            status,
                            installationStatus,
                            allInstallationCompleted,
                            installation_acceptance,
                            min_payment_status,
                            billing_type,
                            noServiceNoTask,
                            proj_status,
                            job_category_name,
                            partial_install,
                          ).label
                    }
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        minWidth:80,
                        maxWidth: 80, // Adjust as necessary
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {designOrder
                          ? getStatusColorAndLabelDesignOrder(status, hold)
                              .label
                          : quotationView
                          ? getStatusColorAndLabelQuickbid(
                              quotation_status,
                              quotation,
                            ).label
                          : proposalView
                          ? getStatusColorAndLabelForProposal(
                              userType != 3 ? (paymentMode? 7:awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                            ).label
                          : getStatusColorAndLabel(
                              status,
                              installationStatus,
                              allInstallationCompleted,
                              installation_acceptance,
                              min_payment_status,
                              billing_type,
                              noServiceNoTask,
                              proj_status,
                              job_category_name,
                              partial_install,
                            ).label}
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              )}
            </Typography>
          


          </Stack>
        </CardMediaStyle>

      

      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            pt: 2,
          }}
        >
          <Tooltip title={name}>
            
            <Typography
              onClick={() => {
                navigate(PATH_DASHBOARD.quotation.viewSplitEstimate.replace(':id', id), {state: {edit: true}})
              }}
              variant="subtitle1"
              sx={{
                maxWidth: userType != 3 && !CommunityProjects ? 150 : '70%',
                cursor: 'pointer',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: theme.palette.primary.main,
                '&:hover': {
                  cursor: CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : quotationView
                    ? explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : designOrder
                    ? explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : explodedPermissions?.some((permission) =>
                        ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                    ? 'pointer'
                    : 'default',
                },
              }}
            >
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {name}
              </span>
            </Typography>
          </Tooltip>
          {((userType != 3 && !CommunityProjects) || proposalView) && (
            <Typography
              onClick={() => {
                navigate(PATH_DASHBOARD.quotation.viewSplitEstimate.replace(':id', id))
              }}
              variant="subtitle1"
              sx={{
                color: theme.palette.primary.main,
              }}
            >
             Details
            </Typography>
          )}
        </Stack>

        <Typography
          variant="subtitle1"
          align="center"
          sx={{ mb: 1, mt: 2 }}
        >
          Last updated {getAgoString(timestamp)}
        </Typography>

        <Typography
          variant="subtitle1"
          align="end"
          sx={{ mt: 'auto', mb: 2, mr: 1 ,color:"green" }}
        >
          {total_cost ?`$${total_cost}` : ""}
        </Typography>
      </Box>
      </Card>


    </>
  )
}
